import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogSiNoData, DialogSiNoComponent } from '../app/dialog-si-no/dialog-si-no.component';
import { FileSystemNode } from '../model/FileSystemNode';
import { DialogCrearDirectorioComponent } from '../app/admin/dialog-crear-directorio/dialog-crear-directorio.component';
import { DialogCrearFileDirectorioSelectorComponent, DialogCrearFileDirectorioSelectorComponentData } from '../app/admin/dialog-crear-file-directorio-selector/dialog-crear-file-directorio-selector.component';
import { DialogCrearFileComponent } from '../app/admin/dialog-crear-file/dialog-crear-file.component';
import { DialogEditItemComponent } from '../app/admin/dialog-edit-item/dialog-edit-item.component';
import { NodeOperationResult } from '../model/NodeOperationResult';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog) { }

  confirm(data: Partial<DialogSiNoData> = {}): Observable<boolean> {
    const dialogData: DialogSiNoData = {
      title: data.title || 'title',
      message: data.message || 'message',
      confirmText: data.confirmText || 'confirmText',
      cancelText: data.cancelText || 'cancelText'
    };

    const dialogRef = this.dialog.open(DialogSiNoComponent, {
      data: dialogData,
      width: '400px'
    });

    return dialogRef.afterClosed();
  }

  agregarDirectorio(node: FileSystemNode): Observable<NodeOperationResult> {
    const dialogData: DialogCrearFileDirectorioSelectorComponentData = {
      node: node
    }
    const dialogRef = this.dialog.open(DialogCrearDirectorioComponent, {
      data: dialogData,
      // width: '12000px'
    });

    return dialogRef.afterClosed();
  }

  agregarFile(node: FileSystemNode): Observable<NodeOperationResult> {
    const dialogData: DialogCrearFileDirectorioSelectorComponentData = {
      node: node
    }
    const dialogRef = this.dialog.open(DialogCrearFileComponent, {
      data: dialogData,
      // width: '12000px'
    });

    return dialogRef.afterClosed();
  }

  /**
   * Crea el dialogo para selecionar creacion de archivo o directorio.
   * 
   * @param node el nodo de trabajo (el que seleccionamos la accion)
   * @returns el tipo de operacion para que lo pueda manejar el consumer? (files.component.ts)
   */
  agregarFileODirectorioSelector(node: FileSystemNode): Observable<NodeOperationResult> {
    const dialogData: DialogCrearFileDirectorioSelectorComponentData = {
      node: node
    }

    const dialogRef = this.dialog.open(DialogCrearFileDirectorioSelectorComponent, {
      data: dialogData,
      // width: '30vw'
      panelClass: 'custom-dialog-container',
    });

    return dialogRef.afterClosed();
  }

  editItem(node: FileSystemNode): Observable<NodeOperationResult> {

    const dialogRef = this.dialog.open(DialogEditItemComponent, {
      data: {},
    });

    return dialogRef.afterClosed();
  }

}